import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { CameraScreen } from '../camera/CameraScreen';

export function CameraRoute() {
  const { jobId } = useParams<{ jobId: string }>();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  if (!jobId) {
    return (
      <div className="p-4 text-sm text-red-600">Missing job ID in URL.</div>
    );
  }

  const modeParam = searchParams.get('mode');
  const mode: 'new' | 'reinspection' =
    modeParam === 'reinspection' ? 'reinspection' : 'new';
  const rtype = searchParams.get('rtype');
  const reinspectionType =
    rtype === 'new_set' || rtype === 'add_to_existing' ? rtype : undefined;
  const gapPreserved = searchParams.get('gap') === '1';

  return (
    <CameraScreen
      jobId={jobId}
      mode={mode}
      reinspectionType={reinspectionType}
      gapPreserved={gapPreserved}
      onWrapUp={() => navigate(`/job/${jobId}/wrap-up`)}
    />
  );
}
